import Footer from "@/features/layout/components/Footer";
import Header from "@/features/layout/components/Header";
import Programas from "@/features/programas/components/Programas";

export default function Index() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 py-6 md:py-8">
        <Programas />
      </main>

      <Footer />
    </div>
  );
}
